// extracted by mini-css-extract-plugin
export default {"mealTable":"FcaIvT5jvlY5VAzTG4k1"};